import { ValueGetterFunc, type ColDef } from 'ag-grid-community';
import { ValueFormatterFunc, ValueFormatterParams } from 'ag-grid-community';
import { BudgetBys } from 'business/constants';
import { translateBackend, translateBlock, translateBlockValue } from 'i18n';
import type { InscriptionHistory } from 'routes/BudgetModule/components/BudgetOverview/AllInscriptions/types';

const formatDate = (date: string): string => {
    return new Date(date)
        .toLocaleString(undefined, {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
        })
        .replace(' ', ', ');
};

const dateFormatter: ValueFormatterFunc = (params: ValueFormatterParams) =>
    params.value ? formatDate(params.value) : '';

const oldValueGetter: ValueGetterFunc<InscriptionHistory, string> = (
    params,
) => {
    const { data } = params;
    if (!data) return '';
    if (data.values.before === '') return '-';
    if (data.modificationType === 'Montant') return data.values.before + ' €';
    if (data.modificationType === 'Statut')
        return data.values.before
            ? translateBlockValue(data.values.before)
            : '';
    else return data.values.before;
};

const newValueGetter: ValueGetterFunc<InscriptionHistory, string> = (
    params,
) => {
    const { data } = params;
    if (!data) return '';
    if (data.values.after === '') return '-';
    if (data.modificationType === 'Montant') return data.values.after + ' €';
    if (data.modificationType === 'Statut')
        return data.values.after ? translateBlockValue(data.values.after) : '';
    if (data.modificationType === 'Déplacement')
        return data.values.after ? translateBlock(data.values.after) : '';
    else return data.values.after;
};
export const getInscriptionsHistoryModalColDefs = (
    budgetProposalBy: BudgetBys,
): ColDef<InscriptionHistory>[] => [
    {
        field: 'resourceName',
        headerName: translateBlock(budgetProposalBy, true),
        filter: 'agTextColumnFilter',
        floatingFilterComponent: 'textFloatingFilter',
        floatingFilter: true,
        enableRowGroup: true,
    },
    {
        field: 'chapterCode',
        headerName: 'Chapitre',
        filter: 'agTextColumnFilter',
        floatingFilterComponent: 'textFloatingFilter',
        floatingFilter: true,
        enableRowGroup: true,
    },
    {
        field: 'natureLabel',
        headerName: 'Nature',
        filter: 'agTextColumnFilter',
        floatingFilterComponent: 'textFloatingFilter',
        floatingFilter: true,
        enableRowGroup: true,
    },
    {
        field: 'modificationType',
        headerName: 'Type de modification',
        filter: 'agTextColumnFilter',
        floatingFilterComponent: 'textFloatingFilter',
        floatingFilter: true,
        enableRowGroup: true,
    },
    {
        field: 'userInfo',
        headerName: 'Modifié par',
        filter: 'agTextColumnFilter',
        floatingFilterComponent: 'textFloatingFilter',
        floatingFilter: true,
        enableRowGroup: true,
        valueFormatter: ({ value }) =>
            value === 'misc.budget.user_deleted'
                ? translateBackend('misc.budget.user_deleted')
                : value,
    },
    {
        field: 'date',
        headerName: 'Date et heure',
        valueFormatter: dateFormatter,
        filter: 'agDateColumnFilter',
        floatingFilterComponent: 'textFloatingFilter',
        floatingFilter: true,
        enableRowGroup: true,
        filterParams: {
            comparator: (filterDate: Date, cellValue: string | Date | null) => {
                if (!cellValue) return -1;
                const cellDate = new Date(cellValue);
                return (
                    cellDate.setHours(0, 0, 0, 0) -
                    filterDate.setHours(0, 0, 0, 0)
                );
            },
        },
    },
    {
        field: 'values',
        headerName: 'Ancienne valeur',
        valueGetter: oldValueGetter,
        filter: 'agTextColumnFilter',
        floatingFilterComponent: 'textFloatingFilter',
        floatingFilter: true,
        enableRowGroup: true,
    },
    {
        field: 'values',
        headerName: 'Nouvelle valeur',
        valueGetter: newValueGetter,
        filter: 'agTextColumnFilter',
        floatingFilterComponent: 'textFloatingFilter',
        floatingFilter: true,
        enableRowGroup: true,
    },
];
